import { useEffect, useState } from "react";
import DefaultRoutes from "./routes/routes";
import { useDispatch, useSelector } from "react-redux";
import html2canvas from "html2canvas";

import { config } from "./redux/slices/auth/configSlice";
import { toast } from "react-toastify";

import { setUserLocation } from "./redux/slices/auth/locationSlice";
import eventEmitter from "./events/eventEmitter";
import {
  LocationAllowModal,
  LocationBlockedModal,
  InactiveModal,
} from "./components";

import FloatingBackground from "./components/common/floatingBackground";
import { connectSocket, disconnectSocket } from "./helper/socket";

function App() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [ShowLocationBloackedModal, setShowLocationBloackedModal] =
    useState(false);
  const [showDomainInactiveModal, setShowDomainInactiveModal] = useState(false);

  const [locationMessage, setLocationMessage] = useState(""); // for 403 message

  const fetchReverseGeocode = async (lat, lon) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
      );
      const data = await response.json();
      const { address } = data;

      // Dispatch to store
      dispatch(setUserLocation({ latitude: lat, longitude: lon, ...address }));
    } catch (error) {
      console.error("Reverse geocoding failed", error);
    }
  };

  const getUserLocation = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        fetchReverseGeocode(latitude, longitude);
        setShowLocationModal(false); // Location granted → close modal
      },
      (error) => {
        console.warn("Location access denied or failed", error);

        if (error.code == error.PERMISSION_DENIED) {
          // User denied location again
          toast.error("Location permission is required to continue.");
          setShowLocationModal(true); // Keep modal open
        } else {
          // Other geolocation errors
          toast.error("Unable to fetch location. Please try again.");
          setShowLocationModal(true);
        }
      }
    );
  };

  const domain = process.env.REACT_APP_FRONT_URL;
  const { error: profileError, data: profileData } = useSelector(
    (state) => state.getProfile
  );

  useEffect(() => {
    const autoConfig = async () => {
      const vpnToken = localStorage.getItem("vpnToken");
      const payload = {
        domain,
        vpnToken,
        parentId: profileData?.user?.parent_user_id,
      };
      try {
        const res = await dispatch(config(payload)).unwrap();
        if (res?.success) {
          // toast.success(res.message);
          // navigate("/home-screen");
        }
        if (res?.status == 404) {
          setShowDomainInactiveModal(true);
        }
      } catch (error) {
        toast.error(error.message);
        console.error("Config Failed:", error);
      }

      setIsLoading(false);
    };

    if (profileData) {
      autoConfig();
    }
  }, [dispatch, profileData]);

  useEffect(() => {
    const handleLocationBlocked = (msg) => {
      setLocationMessage(msg); // set message from backend
      setShowLocationBloackedModal(true); // open modal
    };

    // eventEmitter.on("missingLocation", handleMissingLocation);
    eventEmitter.on("locationBlocked", handleLocationBlocked);

    return () => {
      // eventEmitter.off("missingLocation", handleMissingLocation);
      eventEmitter.off("locationBlocked", handleLocationBlocked);
    };
  }, []);

  useEffect(() => {
    const handler = () => setShowLocationModal(true);
    eventEmitter.on("missingLocation", handler);

    return () => {
      eventEmitter.off("missingLocation", handler);
    };
  }, []);

  const userId = profileData?.user?._id;
  useEffect(() => {
    if (!userId) return;
    connectSocket(
      userId,
      () => console.log("Connection lost!"),
      () => console.log("Socket connected!")
    );

    return () => {
      disconnectSocket(); // Clean up on unmount
    };
  }, [userId]);

  useEffect(() => {
    localStorage.clear();
    document.cookie.split(";").forEach((c) => {
      const cookieName = c.split("=")[0].trim();
      if (cookieName !== "betfrenzy_token") {
        document.cookie =
          cookieName + "=;expires=" + new Date().toUTCString() + ";path=/";
      }
    });
  }, []);

  return (
    <>
      {/* Background Animation */}
      <FloatingBackground />

      <DefaultRoutes />
      {/* {isLoading && <FloatingLoader />} */}

      {showLocationModal && (
        <LocationAllowModal
          open={showLocationModal}
          setOpen={setShowLocationModal}
          onRetry={() => {
            getUserLocation();
          }}
        />
      )}
      {ShowLocationBloackedModal && (
        <LocationBlockedModal
          open={ShowLocationBloackedModal}
          setOpen={setShowLocationBloackedModal}
          message={locationMessage}
          onClick={() => {
            setShowLocationBloackedModal(false);
            window.location.href = "/";
          }}
        />
      )}
      {showDomainInactiveModal && (
        <InactiveModal
          open={showDomainInactiveModal}
          setOpen={setShowDomainInactiveModal}
          onClick={() => {
            window.location.reload("/");
          }}
        />
      )}
    </>
  );
}

export default App;
